module.exports = __webpack_public_path__ + "assets/f37afc5fdb99405253fa9975230c2939.mp4";